import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { RouterSegments } from 'src/app/models/router-segments';

@Injectable({
  providedIn: 'root',
})
export class UpdateServiceDefGuard implements CanActivate {

  constructor(
    private router: Router,
    private authService: AuthService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    // Get the current navigation
    const navigation = this.router.getCurrentNavigation();

    // Check if navigation state exists and has the required data
    const hasRequiredData = navigation?.extras?.state &&
                           navigation.extras.state['instance'];

    if (!hasRequiredData) {
      // No state data available (direct access or page reload)
      // Redirect to service definition page

      const tenantId = route.parent?.params.id;
      const blueprintId = route.parent?.params.blueprintId;

      if (tenantId && blueprintId) {
        this.router.navigate([
          '/',
          this.authService.principal.provider,
          RouterSegments.TENANT,
          tenantId,
          RouterSegments.SERVICE_DEFINITION,
          blueprintId
        ]);
      } else {
        // Fallback to tenant dashboard if params are missing
        this.router.navigate([
          '/',
          this.authService.principal.provider,
          RouterSegments.TENANT,
          tenantId || ''
        ]);
      }

      return false;
    }

    return true;
  }
}
